/* ===========================================================================
   Lookbook lightbox — lookbook-lightbox.js
   Optional, dependency-free, progressive enhancement.
   The gallery is fully functional without this file; it only adds a
   full-screen viewer when section setting "Enable lightbox" is on.

   Accessibility: role="dialog", Escape to close, arrow-key navigation,
   focus returned to the trigger on close, respects reduced-motion via CSS.
   =========================================================================== */
(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-lm-lightbox]');
  if (!sections.length) return;

  var overlay, imgEl, items, current, lastFocus;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'lm-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image viewer');
    overlay.innerHTML =
      '<button class="lm-lightbox__btn lm-lightbox__prev" aria-label="Previous image">&#8249;</button>' +
      '<img class="lm-lightbox__img" alt="">' +
      '<button class="lm-lightbox__btn lm-lightbox__next" aria-label="Next image">&#8250;</button>' +
      '<button class="lm-lightbox__btn lm-lightbox__close" aria-label="Close">&#215;</button>';
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('.lm-lightbox__img');

    overlay.querySelector('.lm-lightbox__close').addEventListener('click', close);
    overlay.querySelector('.lm-lightbox__prev').addEventListener('click', function (e) {
      e.stopPropagation(); step(-1);
    });
    overlay.querySelector('.lm-lightbox__next').addEventListener('click', function (e) {
      e.stopPropagation(); step(1);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', onKey);
  }

  function show(i) {
    current = (i + items.length) % items.length;
    var btn = items[current];
    imgEl.src = btn.getAttribute('data-lm-full');
    imgEl.alt = btn.getAttribute('data-lm-alt') || '';
  }

  function step(dir) { show(current + dir); }

  function open(i) {
    if (!overlay) build();
    lastFocus = document.activeElement;
    show(i);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    overlay.querySelector('.lm-lightbox__close').focus();
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  }

  // Collect every zoomable item across all lookbook sections on the page.
  items = [];
  sections.forEach(function (section) {
    section.querySelectorAll('.lm-season__item--zoom').forEach(function (btn) {
      var index = items.length;
      items.push(btn);
      btn.addEventListener('click', function () { open(index); });
    });
  });
})();
